import { style } from 'typestyle'
export const fitHeight = style({ height: 'fit-content' })
